import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import LibrarySearch from "./libraryList";

const LeaveList = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Library" />

      <div className="container-sm py-md-3">
        <LibrarySearch titleText={"Library"} />
        <section className="top-space "></section>
      </div>
    </>
  );
};
export default LeaveList;
